import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownMenu } from '@nexelem/components';
import { useFormatTaskDuration } from '../../hooks';
import { useCustomTranslation } from '../../../../../../hooks';
import { faCalendarClock } from '@fortawesome/pro-light-svg-icons';
import type { QueueBreakNode } from '../../types';
import { toggleNodeBreakDrawer } from '../NodeBreak/NodeBreakDrawer';

export const NodeBreakPopperNode = ({ node }: { node: QueueBreakNode }) => {
  const formatTaskDuration = useFormatTaskDuration({ compact: true });
  const { t } = useCustomTranslation('common');
  return (
    <DropdownMenu.Item
      className="flex cursor-pointer items-center gap-2 border-border-secondary bg-surface-disabled px-3 py-2 not-first:border-t focus:bg-surface-focus-lighter focus-visible:outline-none"
      onClick={() => toggleNodeBreakDrawer({ node })}
    >
      <FontAwesomeIcon className="size-5! text-icon-darker" icon={faCalendarClock} />
      <div className="flex flex-col items-start">
        <span className="text-s11-sb uppercase">{t('common.break')}</span>
        <span className="text-s11-sb text-text-secondary-darker">{formatTaskDuration(node)}</span>
      </div>
    </DropdownMenu.Item>
  );
};
